import React from 'react'
import { Modal as AntdModal, Space, Spin } from 'antd'
import styled from 'styled-components'

import StyledModal, { ModalLoadContainer } from './style'
import { IModal } from './types'
import { useTxStrings } from '../../transifex'

const StyledAntdModal = styled(AntdModal)`
  ${StyledModal}
`

export type { IModal } from './types'

const Modal = ({
  children,
  visible,
  onClose,
  disableSubmitButton = false,
  onSubmit = () => null,
  variant,
  loading,
  fullscreen,
  width,
  styles,
  modalStyles,
  ...restProps
}: IModal): JSX.Element => {
  const { txLoading } = useTxStrings()

  return (
    <StyledAntdModal
      $styles={styles}
      styles={modalStyles}
      $isFullScreen={fullscreen}
      $isWithFooter={!!restProps.footer}
      style={
        fullscreen
          ? {
              top: '0%',
              left: '0%',
              maxWidth: '100%',
              padding: 0,
            }
          : {}
      }
      $variant={variant}
      open={visible}
      onCancel={onClose}
      onOk={onSubmit}
      okButtonProps={{ disabled: disableSubmitButton }}
      width={fullscreen ? '100%' : width}
      {...restProps}
    >
      {loading ? (
        <>
          <ModalLoadContainer>
            <Space size="middle">
              <Spin size="large" tip={txLoading} />
            </Space>
          </ModalLoadContainer>
        </>
      ) : (
        children
      )}
    </StyledAntdModal>
  )
}

export default Modal
